export default __webpack_public_path__ + "static/media/Interactive Map.8c4bb957.svg";